<template lang="pug">
  Layout
</template>

<script>
import Layout from './views/Layout'

export default {
  name: 'App',
  components: {
    Layout
  },
  data () {
    return {
    }
  },
  mounted(){
    // console.clear()
  }
}
</script>

<style lang="scss">

</style>